/**
 * Módulo centralizado de reglas de validación para formularios Vuetify.
 * Uso: import { V } from '@/helpers/ValidationRules';
 * Ejemplo: :rules="[V.required(), V.email()]"
 */
export const V = {
  /** Campo obligatorio */
  required: (msg = 'Campo requerido') =>
    (v) => !!v || msg,

  /** Longitud mínima */
  minLength: (min, msg) =>
    (v) => (!v || v.length >= min) || (msg || `Mínimo ${min} caracteres`),

  /** Longitud máxima */
  maxLength: (max, msg) =>
    (v) => (!v || v.length <= max) || (msg || `Máximo ${max} caracteres`),

  /** Longitud exacta */
  exactLength: (len, msg) =>
    (v) => (!v || v.length === len) || (msg || `Debe tener ${len} caracteres`),

  /** Formato de email */
  email: (msg = 'Formato de email inválido') =>
    (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || msg,

  /** Solo números (enteros o decimales) */
  numeric: (msg = 'Debe ser un número válido') =>
    (v) => !v || !isNaN(Number(v)) || msg,

  /** Número positivo (> 0) */
  positiveNumber: (msg = 'Debe ser un número mayor a 0') =>
    (v) => !v || Number(v) > 0 || msg,

  /** Número no negativo (>= 0) */
  nonNegative: (msg = 'No puede ser un número negativo') =>
    (v) => v === '' || v === null || v === undefined || Number(v) >= 0 || msg,

  /** Solo alfanuméricos */
  alphanumeric: (msg = 'Solo caracteres alfanuméricos') =>
    (v) => !v || /^[a-zA-Z0-9]+$/.test(v) || msg,

  /** Teléfono (hasta N dígitos) */
  phone: (maxDigits = 10, msg) =>
    (v) => !v || new RegExp(`^\\d{1,${maxDigits}}$`).test(v) || (msg || `Máximo ${maxDigits} dígitos`),

  /** Porcentaje válido (0-100) */
  percentage: (msg = 'Debe ser entre 0% y 100%') =>
    (v) => v === '' || v === null || v === undefined || (Number(v) >= 0 && Number(v) <= 100) || msg,

  /** Sin espacios */
  noSpaces: (msg = 'No se permiten espacios') =>
    (v) => !v || !/\s/.test(v) || msg,

  /** Selección requerida (para selects/arrays) */
  requiredSelect: (msg = 'Debe seleccionar una opción') =>
    (v) => (Array.isArray(v) ? v.length > 0 : !!v) || msg,
};
